import React, { useContext, useEffect } from "react";
import Generator from "../pages/Generator";
import Playlists from "../pages/Playlists";
import ReactGA from "react-ga";
import Home from "../pages/Home";
import Explore from "../pages/Explore";
import { PlaylistStore } from "../context/ContextProvider";
import {
  Switch,
  Route,
  useHistory,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import AlbumPage from '../pages/AlbumPage'   

import CategoryPlaylists from "../pages/CategoryPlaylists";
import queryString from "query-string";



const PageRouter = () => {
  const parsed = queryString.parse(window.location.search);
  const contextStore = useContext(PlaylistStore);
  const { dispatch, state } = contextStore;
  const { path, url } = useRouteMatch();
  const { accessToken, selectedCategory, songToGenerate } = state;
  const history = useHistory();
  const location = useLocation();

  history.listen((locations, action) => {
    ReactGA.set({ page: locations.pathname });
    ReactGA.pageview(locations.pathname);
  });

  useEffect(() => {
    if (location.pathname !== "/app/generator") {
      dispatch({ type: "setSongToGenerate", payload: {} });
      dispatch({ type: "setOnGenerator", payload: false });
      // dispatch({ type: "setRerolled", payload: false });
    } else {
      dispatch({ type: "setOnGenerator", payload: true });
    }

    if (location.pathname !== "/app/playlists") {
      dispatch({ type: "clearSearch" });
    }
    if (location.pathname == "/app" || location.pathname == "/app/") { 
      history.push("/app/home");
    }
  
    
  }, [location]);

  useEffect(() => {
    if (Object.keys(songToGenerate).length > 0) {
      history.push("/app/generator");
    }
  }, [songToGenerate]);

  // useEffect(() => {
   
  //   if (!accessToken) {
  //     history.push("/app/home");
  //   }
  // }, [accessToken]);

  useEffect(() => {
    getAccessToken();

    return () => {
      
      
    }
  }, []);

  const getAccessToken = async () => {
    const token = sessionStorage.getItem("accessToken");

    if (token) {
      dispatch({ type: "setAccessToken", payload: token });
      
    } else if (parsed.access_token) {
      dispatch({ type: "setAccessToken", payload: parsed.access_token });
      sessionStorage.setItem("accessToken", parsed.access_token);
      history.push("/app/home");
    } else {
      console.log("no token available!");
      history.push("/");
    }
  };

  // useEffect(() => {
  //   if (Object.keys(selectedCategory).length > 0) {
  //     history.push("/app/categories/:id");
  //   }
  // }, [selectedCategory]);

  return (
    <Switch>
      <Route path={`/app/home`}>
        <Home />
      </Route>
      <Route path={`/app/explore`}>
        <Explore />
      </Route>
      <Route path={`/app/generator`}>
        <Generator />
      </Route>
      <Route path={`/app/playlists`}>
        <Playlists />
      </Route>
      <Route path={`/app/album/:id`}>
        <AlbumPage type="album" />
      </Route>
      <Route path={`/app/playlist/:id`}>
        <AlbumPage type="playlist" />
      </Route>

      <Route path={`/app/categories/:id`}>
        <CategoryPlaylists />
      </Route>
    
    
    </Switch>
  );
};

export default PageRouter;
